import { sheetNumber } from "./tulFonSheetModel";

const text = (doc, value, x, y, size = 8, bold = false, options = {}) => {
  doc.setFont("NotoSans", bold ? "bold" : "normal");
  doc.setFontSize(size); doc.setTextColor(28, 33, 39);
  doc.text(String(value), x, y, options);
};

export function drawCurtain(doc, item, x, y, width = 78) {
  const left = x + 12, right = x + width, top = y + 9, bottom = y + 31;
  const span = right - left, middle = left + span / 2;
  doc.setDrawColor(30, 41, 59); doc.setLineWidth(0.65);
  doc.line(left, top, right, top);
  doc.line(left, top, left, bottom);
  doc.line(right, top, right, bottom);
  doc.line(left, bottom, left + 4, bottom);
  doc.line(right - 4, bottom, right, bottom);
  if (item.wings === 2) {
    doc.line(middle, top, middle, top + 5);
    doc.setLineWidth(0.2); doc.setLineDashPattern([1.1, 1.1], 0);
    doc.line(middle, top + 6, middle, bottom);
    doc.setLineDashPattern([], 0);
  }
  // Light pleat strokes remain distinct when printed in monochrome.
  doc.setDrawColor(208, 213, 219); doc.setLineWidth(0.18);
  for (let i = 1; i < 12; i++) {
    if (i === 6 && item.wings === 2) continue;
    const px = left + span * i / 12;
    doc.line(px, top + 1, px - 0.8, bottom - 1.5);
  }
  const en = item.width ? `${sheetNumber(item.width / (item.wings || 1))} cm` : "En eksik";
  if (item.wings === 2) {
    text(doc, en, left + span / 4, y + 5, 10, true, { align: "center" });
    text(doc, en, middle + span / 4, y + 5, 10, true, { align: "center" });
  } else text(doc, en, middle, y + 5, 10, true, { align: "center" });
  doc.setDrawColor(50, 60, 70); doc.setLineWidth(0.2);
  doc.line(left - 4, top, left - 4, bottom);
  doc.line(left - 5.3, top, left - 2.7, top);
  doc.line(left - 5.3, bottom, left - 2.7, bottom);
  text(doc, item.height ? `Boy ${sheetNumber(item.height)} cm` : "Boy eksik", left - 6.5, bottom - 0.5, 8, true, { angle: 90 });
  doc.setFillColor(255, 255, 255); doc.rect(left + 1, top + 8, span - 2, 6, "F");
  text(doc, item.wings ? (item.wings === 2 ? "SOL KANAT      |      SAĞ KANAT" : "TEK KANAT") : "KANAT SEÇİMİ BELİRTİLMEDİ", middle, top + 12, 6.8, true, { align: "center" });
  text(doc, `Toplam bitmiş en: ${item.width ? sheetNumber(item.width) + " cm" : "Eksik"}`, middle, y + 37, 8, true, { align: "center" });
}

export function measureTailorBlocks(doc, item) {
  doc.setFont("NotoSans", "normal"); doc.setFontSize(8);
  const detailLines = item.rows.flatMap(([label, value]) =>
    doc.splitTextToSize(`${label}: ${value}`, 79).map(line => ({ line, note: label === "Terzi notu" })));
  doc.setFont("NotoSans", "bold"); doc.setFontSize(10);
  const roomLines = doc.splitTextToSize(item.room, 68);
  // Large notes and unusually long room names continue without truncation.
  const headingLines = roomLines.slice(0, 2);
  if (roomLines.length > 2) {
    doc.setFont("NotoSans", "normal"); doc.setFontSize(8);
    detailLines.unshift(...doc.splitTextToSize(`Oda / Bölüm (tam ad): ${item.room}`, 79).map(line => ({ line, note: false })));
  }
  const blocks = [];
  const headerHeight = Math.max(14, headingLines.length * 4.1 + 8);
  for (let start = 0; start < detailLines.length; start += 32) {
    const lines = detailLines.slice(start, start + 32);
    blocks.push({ item, lines, roomLines: headingLines, continued: start > 0,
      headerHeight, height: headerHeight + 42 + lines.length * 3.7 + 12 });
  }
  return blocks;
}

export function drawTailorBlock(doc, block, x, y, width = 89) {
  const { item, headerHeight, height, roomLines, lines, continued } = block;
  doc.setFillColor(30, 41, 59); doc.rect(x, y, width, headerHeight, "F");
  doc.setFont("NotoSans", "bold"); doc.setFontSize(10); doc.setTextColor(255);
  doc.text(roomLines, x + 4, y + 5, { lineHeightFactor: 1.16 });
  doc.setFontSize(8); doc.text(String(item.number).padStart(2, "0"), x + width - 4, y + 5, { align: "right" });
  doc.setFontSize(7.5);
  doc.text(`${item.type} · ${sheetNumber(item.qty)} adet${continued ? " · DEVAM" : ""}`, x + 4, y + headerHeight - 2.5);
  doc.setDrawColor(192, 199, 207); doc.setLineWidth(0.25);
  doc.rect(x, y, width, height);
  drawCurtain(doc, item, x + 4, y + headerHeight, 79);
  let lineY = y + headerHeight + 44;
  lines.forEach(({ line, note }) => {
    text(doc, line, x + 4, lineY, 8, note);
    lineY += 3.7;
  });
  const stripY = y + height - 9;
  doc.setFillColor(241, 245, 248); doc.rect(x + 0.3, stripY, width - 0.6, 8.7, "F");
  text(doc, item.valid ? `${sheetNumber(item.mtul)} mtül/adet · Toplam ${sheetNumber(item.total)} mtül` : "ÖLÇÜ EKSİK — ÜRETİM ÖNCESİ TAMAMLAYIN", x + 4, stripY + 3.7, 7.4, true);
  text(doc, `Kumaş eni ${sheetNumber(item.fabricWidth)} cm · ${item.vertical ? "Dikine birleştirme" : "Standart metraj"}`, x + 4, stripY + 7, 6.5);
}